export default "__VITE_ASSET__DEfIDDHl__"